<form [formGroup]="formGroup" class="grid-container margin-top wrapper">
  <div class="grid-x grid-margin-x">
    <div class="cell large-12 medium-12 small-12 text-align-center bold">
      <h3 class="h4">Document Scanning Request @if (requestId) {
        : {{requestId}}
      }</h3>
    </div>
    <div class="cell large-3 bold">
      Date / Time of Request:
    </div>
    <div class="cell large-3">
      {{ currentRequest.timeOfRequest | date: 'MMMM d, y, h:mm a'}}
    </div>
    <div class="cell large-3 bold text-align-right" [ngClass]="{ 'red' : dateInvalid }">
      Date DOGRM Received Document@if (isEditing) {
      <span>*</span>
      }:
    </div>
    <div class="cell large-3">
      @if (!isEditing) {
        {{ currentRequest.dateDocumentReceived | date: 'MM/dd/yyyy'}}<delta-bubble [expectedDataType]="'Date'" [currentValue]="currentRequest.dateDocumentReceived" [originalValue]="originalRequest.dateDocumentReceived"></delta-bubble>
      }
      @if (isEditing) {
        <common-date-picker [id]="'receivedDate'" (dateUpdated)="receivedDateChanged($event)" [initialDate]="receivedDate"></common-date-picker>
      }
    </div>
    <div class="cell large-3 bold" [ngClass]="{ 'red': groupInvalid }">
      Group Making the Request@if (isEditing) {
      <span>*</span>
      }:
    </div>
    <div class="cell large-3 padding-right align-self-start">
      @if (departments != null && departments.length !== 0) {
        <select formControlName="group">
          @for (group of departments; track group) {
            <option [value]="group.id">{{group.displayName}}</option>
          }
        </select>
      }
      <text-loader [run]="departments == null" [text]="'Loading Groups'" [tickType]="'.'" [interval]="2000"></text-loader>
      <delta-bubble [domain]="departments" [domainIdProperty]="'id'" [domainDisplayProperty]="'displayName'" [expectedDataType]="'Domain'" [originalValue]="originalRequest.groupRequesting" [currentValue]="currentRequest.groupRequesting"></delta-bubble>
    </div>
    <div class="cell large-3 bold text-align-right" [ngClass]="{ 'red': formGroup.get('requestor')?.invalid }">
      Requestor@if (isEditing) {
      <span>*</span>
      }:
    </div>
    <div class="cell large-3 align-self-start">
      @if (groups != null && groups.length !== 0) {
        <select formControlName="requestor">
          @for (group of groups; track group) {
            <option [value]="group.id">{{group.displayName}}</option>
          }
        </select>
      }
      <text-loader [run]="groups == null" [text]="'Loading Groups'" [tickType]="'.'" [interval]="2000"></text-loader>
      <delta-bubble [domain]="groups" [domainIdProperty]="'id'" [domainDisplayProperty]="'displayName'" [expectedDataType]="'Domain'" [originalValue]="originalRequest.requestor" [currentValue]="currentRequest.requestor"></delta-bubble>
    </div>
    <div class="cell large-12 bold padding-bottom">
      Document Details <span class="italic padding-left-large">Each document needs to be scanned individually.</span>
    </div>
    <div class="cell large-12">
      <div class="grid-container border-one-pixel-solid-gray">
        <div class="grid-x padding-all">
          <div class="cell large-3 bold" [ngClass]="{ 'red' : formGroup.get('documentGroup')?.invalid }">
            Document Group@if (isEditing) {
            <span>*</span>
            }:
          </div>
          <div class="cell large-9 align-self-start">
            @if (documentGroups?.length > 0) {
              <select formControlName="documentGroup" (change)="documentGroupChanged($event)">
                @for (documentGroup of documentGroups; track documentGroup) {
                  <option [ngValue]="documentGroup.id">{{documentGroup.name}}</option>
                }
              </select>
            }
            <delta-bubble [expectedDataType]="'string'" [originalValue]="originalRequest.documentGroup" [currentValue]="currentRequest.documentGroup"></delta-bubble>
            <text-loader [run]="documentGroups == null" [text]="'Loading Document Groups'" [tickType]="'.'" [interval]="3000"></text-loader>
          </div>
          <div class="cell large-3 bold" [ngClass]="{ 'red' : formGroup.get('documentType')?.invalid }">
            Type / Name of Document@if (isEditing) {
            <span>*</span>
            }:
          </div>
          <div class="cell large-9 align-self-start">
            @if (documentTypes?.length > 0) {
              <select formControlName="documentType">
                @for (doc of documentTypes; track doc) {
                  <option [ngValue]="doc.id">{{doc.name}}</option>
                }
              </select>
            }
            <delta-bubble [expectedDataType]="'string'" [originalValue]="originalRequest.documentType" [currentValue]="currentRequest.documentType"></delta-bubble>
            <text-loader [run]="documentTypes == null" [text]="'Loading Document Types'" [tickType]="'.'" [interval]="3000"></text-loader>
          </div>
          <div class="cell large-12 bold" [ngClass]="{ 'red': isEditing && !hasSearchOption }">
            Look up Values@if (isEditing) {
            <span>*</span>
            }:
          </div>
          <div class="cell large-12 bold">
            Minimum Selection: 1 Lookup Field
          </div>
          <div class="cell large-2 bold padding-left-large text-align-right padding-right-small">
            API Number:
          </div>
          <div class="cell large-2">
            <input type="text" formControlName="apiNumber" (keydown)="invalidateField('apiFound')" />
          </div>
          <div class="cell large-2 padding-left">
            @if (!isEditing) {
              <delta-bubble [expectedDataType]="'String'" [originalValue]="originalRequest.apiNumber" [currentValue]="currentRequest.apiNumber"></delta-bubble>
            }
            @if (isEditing) {
              <button class="button" (click)="searchAPI()"><svg-icon icon="icon-data-lookup" class="small black"></svg-icon></button>
              @if (apiSearchRun || apiValid) {
                <span>
                  @if (formGroup.get('apiNumber')?.dirty) {
                    <span class="red">
                      @if (apiValid) {
                        <svg-icon icon="icon-checkbox" class="large green"></svg-icon>
                      }
                      @if (!apiValid) {
                        <svg-icon class="tiny red" icon="icon-alert"></svg-icon>
                        No results
                      }
                    </span>
                  }
                </span>
              }
            }
          </div>
          <div class="cell large-2 bold padding-left text-align-right padding-right-small">
            Application Number:
          </div>
          <div class="cell large-2">
            <input type="text" formControlName="applicationNumber" (keydown)="invalidateField('applicationNumberFound')"/>
          </div>
          <div class="cell large-2 padding-left">
            @if (!isEditing) {
              <delta-bubble [expectedDataType]="'String'" [originalValue]="originalRequest.applicationNumber" [currentValue]="currentRequest.applicationNumber"></delta-bubble>
            }
            @if (isEditing) {
              <button class="button" (click)="searchApplications()"><svg-icon icon="icon-data-lookup" class="small black"></svg-icon></button>
              @if (applicationSearchRun || applicationValid) {
                <span>
                  @if (formGroup.get('applicationNumber')?.dirty) {
                    <span class="red">
                      @if (applicationValid) {
                        <svg-icon icon="icon-checkbox" class="large green"></svg-icon>
                      }
                      @if (!applicationValid) {
                        <svg-icon class="tiny red" icon="icon-alert"></svg-icon>
                        No results
                      }
                    </span>
                  }
                </span>
              }
            }
          </div>
          <div class="cell large-2 bold text-align-right padding-right-small">
            RICS Owner Number:
          </div>
          <div class="cell large-2">
            <input type="text" formControlName="organizationNumber" (keydown)="invalidateField('organizationNumberFound')" />
          </div>
          <div class="cell large-2 padding-left">
            @if (!isEditing) {
              <delta-bubble [expectedDataType]="'String'" [originalValue]="originalRequest.organization" [currentValue]="currentRequest.organization"></delta-bubble>
            }
            @if (isEditing) {
              <button class="button" (click)="searchOrganizations()"><svg-icon icon="icon-data-lookup" class="small black"></svg-icon></button>
              @if (organizationSearchRun || organizationValid) {
                <span>
                  @if (formGroup.get('organizationNumber')?.dirty) {
                    <span class="red">
                      @if (organizationValid) {
                        <svg-icon icon="icon-checkbox" class="large green"></svg-icon>
                      }
                      @if (!organizationValid) {
                        <svg-icon class="tiny red" icon="icon-alert"></svg-icon>
                        No results
                      }
                    </span>
                  }
                </span>
              }
            }
          </div>
          <div class="cell large-2 bold padding-left">
            RBDMS Owner Number:
          </div>
          <div class="cell large-2">
            <input type="text" formControlName="rbdmsNumber" (keydown)="invalidateField('rbdmsNumberFound')" />
          </div>
          <div class="cell large-2 padding-left">
            @if (!isEditing) {
              <delta-bubble [expectedDataType]="'String'" [originalValue]="originalRequest.rbdmsNumber" [currentValue]="currentRequest.rbdmsNumber"></delta-bubble>
            }
            @if (isEditing) {
              <button class="button" (click)="searchRBDMS()"><svg-icon icon="icon-data-lookup" class="small black"></svg-icon></button>
              @if (rbdmsNumberSearchRun || rbdmsValid) {
                <span>
                  @if (formGroup.get('rbdmsNumber')?.dirty) {
                    <span class="red">
                      @if (rbdmsValid) {
                        <svg-icon icon="icon-checkbox" class="large green"></svg-icon>
                      }
                      @if (!rbdmsValid) {
                        <svg-icon class="tiny red" icon="icon-alert"></svg-icon>
                        No results
                      }
                    </span>
                  }
                </span>
              }
            }
          </div>
          <div class="cell large-2">
            <div class="checkbox">
              <input id="legal" type="checkbox" formControlName="legalReview" class="show-for-sr" />
              <label for="legal">
                <span class="checkbox-box" aria-hidden="true">
                  <span class="checkbox-check" aria-hidden="true">&#x2714;</span>
                </span>
                Legal Review Required
              </label>
            </div>
          </div>
          <div class="cell large-10">
            <delta-bubble [expectedDataType]="'Boolean'" [originalValue]="originalRequest.legalReviewRequired" [currentValue]="currentRequest.legalReviewRequired"></delta-bubble>
          </div>
          <div class="cell large-2">
            <div class="checkbox">
              <input id="confidential" type="checkbox" formControlName="confidential" class="show-for-sr" />
              <label for="confidential">
                <span class="checkbox-box" aria-hidden="true">
                  <span class="checkbox-check" aria-hidden="true">&#x2714;</span>
                </span>
                Private &amp; Confidential
              </label>
            </div>
          </div>
          <div class="cell large-10">
            <delta-bubble [expectedDataType]="'Boolean'" [originalValue]="originalRequest.confidential" [currentValue]="currentRequest.confidential"></delta-bubble>
          </div>
          <div class="cell large-4 bold">
            Number of Pages (Including Coversheet):
          </div>
          <div class="cell large-1 text-align-left">
            <input type="number" formControlName="pages" min="0" />
          </div>
          <div class="cell large-7 text-align-left"><delta-bubble [expectedDataType]="'Number'" [originalValue]="originalRequest.pages" [currentValue]="currentRequest.pages"></delta-bubble></div>
        </div>
      </div>
    </div>
    <div class="cell large-12">
      <div [ngStyle]="{ 'display': (inScanningGroup) ? 'inherit': 'none' }">
        <upload-view-files [componentLabel]="'Upload Scanned Image'" (newFilesList)="appendFiles($event)"></upload-view-files>
      </div>
      @if (files?.length > 0) {
        <h3 class="minor-margin-bottom h6">Uploaded Files</h3>
        @for (file of files; track file) {
          <div class="flex">
            <uploaded-file [allowFileDeletion]="inScanningGroup" [file]="file" (fileDeleted)="deleteFile($event)"></uploaded-file>
          </div>
        }
      }
    </div>
    <div class="cell large-12 bold">
      Notes / Instructions: <delta-bubble [expectedDataType]="'String'" [originalValue]="originalRequest.instructions" [currentValue]="currentRequest.instructions"></delta-bubble>
    </div>
    <div class="cell large-12">
      <textarea formControlName="instructions"></textarea>
    </div>
    <div class="cell large-12 bold">
      Comments from Scanning:
    </div>
    @if (currentStep !== steps.LegalReview) {
      <div class="cell large-12">
        <textarea formControlName="scanningComments"></textarea>
      </div>
    }
    @if (currentStep === steps.LegalReview) {
      <div class="cell large-12">
        {{formGroup?.get('scanningComments')?.value}}
      </div>
    }
    @if (currentStep !== steps.Loading && currentStep !== steps.InitialScan) {
      <div class="cell large-12 bold">
        Comments from Legal:
      </div>
      @if (currentStep === steps.LegalReview) {
        <div class="cell large-12">
          <textarea  formControlName="legalComments"></textarea>
        </div>
      }
      @if (currentStep !== steps.LegalReview) {
        <div class="cell large-12">
          {{formGroup?.get('legalComments')?.value}}@if (currentRequest && (currentRequest.legalComments == null || currentRequest.legalComments === '')) {
          <span class="red bold">Not submitted to Legal or no comments from Legal.</span>
        }
      </div>
    }
  }
  @if (index?.state === steps.Rejected) {
    <div class="cell large-12 bold">
      Reasons for Rejection:
    </div>
    <div class="cell large-12">
      {{formGroup?.get('rejectReason')?.value}}
    </div>
  }
  @if (!isEditing) {
    <div class="cell large-6 text-align-center">
      <button class="button" [disabled]="!enableButtons" (click)="editRequest()">Edit</button>
    </div>
    @switch (currentStep) {
      @case (steps.DocumentGroup) {
        <div class="cell large-6 text-align-center">
          <span class="padding-right">
            <button class="button" [disabled]="!enableButtons || formGroup.invalid" (click)="rejectScan()">Reject</button>
          </span>
          <span class="padding-left">
            <button class="button" [disabled]="!enableButtons || formGroup.invalid" (click)="documentGroupConfirm()">Accept</button>
          </span>
        </div>
      }
      @case (steps.LegalReview) {
        <div class="cell large-6 text-align-center">
          <button class="button" [disabled]="!enableButtons || formGroup.invalid" (click)="completeLegalReview()">Review Complete</button>
        </div>
      }
      @default {
        <div class="cell large-6 text-align-center">
          <span [ngClass]="{ 'padding-right': currentStep === steps.ReturnedToScanning }">
            @if (legalReview || currentStep === steps.ReturnedToScanning) {
              <button class="button" [disabled]="!enableButtons || formGroup.invalid" (click)="sendToLegal()">Legal Review</button>
            }
          </span>
          <span [ngClass]="{ 'padding-left': currentStep === steps.ReturnedToScanning }">
            @if (!legalReview || currentStep === steps.ReturnedToScanning) {
              <button class="button" [disabled]="!enableButtons || formGroup.invalid" (click)="completeScan()">{{completeButtonText}}</button>
            }
          </span>
        </div>
      }
    }
  }
  @if (isEditing) {
    <div class="cell large-12">
      <button class="button" (click)="save()">Save</button>
    </div>
  }
</div>
</form>
<a style="display: none;" href="" target="_blank" #downloadLink></a>